import React, { useState } from "react";
import logo from "../../images/homepage/logoNew.svg";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

export const FooterNew = ({ show, setShow }) => {
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const [showCopyRight, setShowCopyRight] = useState(false);
  const handleCloseCopyRight = () => setShowCopyRight(false);
  const handleShowCopyRight = () => setShowCopyRight(true);
  return (
    <footer className="footer-new">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-12 mb-4">
            <div className="">
              <div className="footer-logo">
                <a href="#">
                  <img src={logo} alt="Images" />
                </a>
              </div>
              <p className="desc">
                {" "}
                DISCLAIMER: We are an Educational Platform/Teachers, We dont ask
                for investments and we are not financial advisors. The Following
                groups are the only offical groups of Waqar Zaka.{" "}
              </p>
              <div className="social-link">
                <a href="https://www.facebook.com/waqarzaka/" target="_blank">
                  <i className="fa-brands fa-facebook-f" />
                </a>

                <a href="https://twitter.com/zakawaqar" target="_blank">
                  <i className="fa-brands fa-twitter" />
                </a>

                <a
                  href="https://www.instagram.com/waqarzaka/?hl=en"
                  target="_blank"
                >
                  <i className="fa-brands fa-instagram" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-6 mb-4">
            <div className=" ps-5">
              <h3>Resources</h3>
              <ul className="footer-list">
                <li>
                  <a href="#"> Home </a>
                </li>
                {/* <li>
                  <a onClick={() => setShow(true)}> Courses </a>
                </li> */}
                <li>
                  <a href="#about"> About </a>
                </li>
                {/* <li>
                  <a href="#testimonial"> Testimonial </a>
                </li> */}
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-6 mb-4">
            <div className=" ps-5">
              <h3>Official Info</h3>
              <ul className="footer-contact">
                {/* <li><i className="fa-solid fa-location-dot" />
                <div className="content">
                  <h5>Location:</h5>
                  <span>DSO_IFZA IFZA Properties Dubai Silicon Oasis</span>
                </div>
              </li> */}
                <li>
                  <div className="content d-flex flex-wrap">
                    <h4 className="me-1 mb-0">Email:</h4>
                    <a href="mailto:info@waqarzaka.net">info@waqarzaka.net</a>
                  </div>
                </li>
                <li>
                  <div className="content">
                    <Link to="/terms-and-conditions">Terms & conditions</Link>
                  </div>
                </li>
                <li>
                  <div className="content">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </div>
                </li>
                <li>
                  <div className="content">
                    <Link onClick={handleShowCopyRight}>Copyright ©️ 2026</Link>
                  </div>
                </li>
                {/* <li>
                  <div className="content">
                    <a>Powered by Capital Media LLC</a>
                  </div>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="copyright-area">
          <div className="container">
            <div className="copy-right-text text-center">
              <p>
                {" "}
                Copyright © 2026 <b>Waqar Zaka</b> All Rights Reserved ,
                <span style={{ fontSize: 13 }}> Capital Media LLC</span>
              </p>
            </div>
          </div>
        </div>

        <div className="termsFooter">
          <h6 style={{ fontSize: 14 }}>
            LEGAL DISCLAIMER & TERMS OF USE/CONDITIONS
          </h6>
          <p className="mb-3" style={{ fontSize: 13 }}>
            <b>Last Updated:</b> 20.03.2025{" "}
          </p>
          <p className="mb-3" style={{ fontSize: 13 }}>
            Welcome to www.waqarzaka.net (the "Website"). By accessing or using
            this Website, you agree to the following disclaimers, terms, and
            policies. If you do not agree with any part of this disclosure,
            please discontinue use immediately.{" "}
            <span className=" more cursor-pointer" onClick={handleShowMore}>
              See More
            </span>
          </p>
        </div>
      </div>
      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM">
              <div className="showMoreModal py-4">
                <h3>GLOBAL LEGAL DISCLAIMER & TERMS OF USE/CONDITIONS</h3>
                <p className="mb-3">
                  <b>Last Updated:</b> 20.03.2025{" "}
                </p>
                <p className="mb-3">
                  Welcome to www.waqarzaka.net (the "Website"). By accessing or
                  using this Website, you agree to the following disclaimers,
                  terms, and policies. If you do not agree with any part of this
                  disclosure, please discontinue use immediately.{" "}
                </p>

                <p className="mb-3">
                  For <a href="https://waqarzaka.net/">www.waqarzaka.net</a> &
                  All Associated Signal / Telegram / WhatsApp Groups
                </p>

                <h5>Educational & Informational Use Only</h5>
                <p>
                  All content, crypto signals, trading strategies, commentary,
                  or communications shared via{" "}
                  <a href="https://waqarzaka.net/">www.waqarzaka.net</a> or its
                  affiliated platforms (including but not limited to Signal,
                  Telegram, WhatsApp, or email) are intended solely for
                  educational and informational purposes.
                </p>
                <p className="mb-3">
                  They are not a substitute for professional financial, legal,
                  or tax advice.
                </p>

                <h5>
                  No Financial Advice – Opinions Only (with Global
                  Jurisdictional Disclaimer)
                </h5>
                <p className="mb-3">
                  Waqar Zaka and his team may share personal opinions, trade
                  setups, and buy/sell signals as part of their educational
                  services. However, all such content is provided strictly for
                  informational purposes and does not constitute financial
                  advice, portfolio management, or a recommendation to trade any
                  specific asset.
                </p>
                <p className="mb-3">You acknowledge and agree that:</p>
                <p className="mb-3">
                  Waqar Zaka and his team are not licensed financial advisors,
                  brokers, or investment professionals in any jurisdiction,
                  including but not limited to:
                </p>
                <ul>
                  <li>The United States (SEC, CFTC, FINRA),</li>
                  <li>The United Kingdom (FCA),</li>
                  <li>The European Union (ESMA),</li>
                  <li>The United Arab Emirates (SCA, DFSA),</li>
                  <li>
                    Singapore (MAS) and all other global regulatory bodies.
                  </li>
                </ul>
                <p className="mb-3">
                  All information shared is general in nature, not customized to
                  your financial circumstances, and does not establish any
                  fiduciary duty or client-advisor relationship.
                </p>
                <p className="mb-3">
                  Waqar Zaka and his team do not solicit, induce, or guarantee
                  any outcome or return. Past performance is not indicative of
                  future results.
                </p>
                <p className="mb-3">
                  By using our content, you waive all claims of
                  misrepresentation, reliance, market manipulation, or legal
                  liability under any financial services or securities
                  regulation worldwide.
                </p>
                <h5>No Guarantee of Results</h5>
                <p>
                  We make no warranties, express or implied, regarding the
                  accuracy, reliability, timeliness, or future performance of
                  any content.
                </p>
                <p className="mb-3">
                  You acknowledge that all forms of trading and investing carry
                  inherent risks, including the loss of your entire capital.
                </p>
                <h5>Jurisdictional Restrictions</h5>
                <p>
                  Our services are not intended for use in jurisdictions where
                  the transmission or use of such content would be unlawful or
                  restricted.
                </p>
                <p>
                  You are solely responsible for ensuring your participation
                  complies with local laws, financial regulations, and
                  restrictions.
                </p>

                <h5>Limitation of Liability</h5>
                <p className="mb-3">
                  Waqar Zaka and all related parties (including team members,
                  affiliates, contractors, and contributors) shall not be held
                  liable for any form of damages — direct, indirect, incidental,
                  punitive, or consequential — including but not limited to:
                </p>
                <ul>
                  <li>Loss of capital or profits,</li>
                  <li>Missed trades or opportunities,</li>
                  <li>Trading errors based on content reliance,</li>
                  <li>Or emotional, legal, or financial distress.</li>
                </ul>

                <p className="mb-3">
                  This limitation applies regardless of the legal theory, even
                  if advised of the possibility of such damages.
                </p>

                <h5>Personal Responsibility & Risk Acceptance</h5>
                <p className="mb-3">You are solely responsible for:</p>
                <ul>
                  <li>Evaluating all shared information,</li>
                  <li>Conducting your own due diligence,</li>
                  <li>Consulting with a qualified financial professional,</li>
                  <li>Making independent investment or trading decisions.</li>
                </ul>
                <p className="mb-3">
                  By participating, you voluntarily assume all risks, and agree
                  to indemnify and hold harmless Waqar Zaka and associated
                  parties from any legal action, claim, or loss arising out of
                  your use of our services.
                </p>
                <h5>No Refund – No Chargeback Policy</h5>
                <p>
                  Due to the nature of digital and educational content, all
                  payments made for services, access, or subscriptions are
                  non-refundable.
                </p>
                <p className="mb-3">
                  By proceeding with any payment, you waive any right to
                  refunds, disputes, or chargebacks, regardless of perceived
                  results or experience.
                </p>
                <h5>Binding Agreement</h5>
                <p className="mb-3">
                  By accessing{" "}
                  <a href="https://waqarzaka.net/">www.waqarzaka.net</a> or any
                  related groups, you confirm that you:
                </p>
                <ul>
                  <li>
                    Have read, understood, and accepted this disclaimer in full,
                  </li>
                  <li>Enter into a binding agreement,</li>
                  <li>
                    And irrevocably waive any future legal claims based on
                    reliance, misunderstanding, or dissatisfaction.
                  </li>
                </ul>
                <p className="mb-3">
                  This disclaimer shall be governed by applicable international
                  and local laws, and any disputes shall be resolved under the
                  jurisdiction Waqar Zaka or his company designates.
                </p>
                <p>
                  <b>Final Note</b>
                </p>
                <p>You trade at your own risk.</p>
                <p>
                  Waqar Zaka and his team are not responsible for your profits,
                  losses, decisions, or emotions.
                </p>
                <p>Your risk. Your decision. Your responsibility.</p>

                <h5>GENERAL DISCLAIMER</h5>
                <p className="mb-3">
                  This Website is for educational and informational purposes
                  only. We do not provide financial, investment, legal, or tax
                  advice. Any content, materials, or courses available on this
                  platform should not be construed as professional financial
                  guidance. Before making any trading or investment decisions,
                  consult with a licensed financial advisor, attorney, or tax
                  professional to assess your individual circumstances.
                </p>
                <h5>NO FINANCIAL OR INVESTMENT ADVICE</h5>
                <p className="mb-3">
                  We are not financial advisors, brokers, or investment
                  professionals. No content on this Website constitutes
                  financial, investment, or legal advice. Any financial or
                  trading decisions you make based on our content are at your
                  own risk. Past performance of financial markets,
                  cryptocurrencies, or trading strategies is not indicative of
                  future results.
                </p>
                <h5>Risk Disclosure</h5>

                <p className="mb-3">
                  Trading and investing involve substantial risk, including
                  potential loss of your entire investment. The cryptocurrency
                  and forex markets are highly volatile and not suitable for all
                  investors. You should only trade or invest money that you can
                  afford to lose.
                </p>
                <h5>Personal Responsibility</h5>
                <p className="mb-3">
                  By using this Website, you acknowledge that you are solely
                  responsible for your financial decisions. We are not liable
                  for any financial losses, damages, or negative outcomes from
                  using our educational materials
                </p>
                <p className="mb-3">
                  We do not guarantee any specific financial outcomes, earnings,
                  or success from using our content. Any testimonials, success
                  stories, or examples are exceptional cases and not typical
                  results. Your personal financial success depends on various
                  factors outside our control, including market conditions,
                  experience, and risk tolerance.
                </p>
                <p className="mb-3">
                  All information is provided "as is" and "as available", with
                  no warranties of accuracy, completeness, or reliability. We
                  strive to provide up-to-date information, but we do not
                  guarantee that all content is free from errors, omissions, or
                  outdated material. By accessing this Website, you agree that
                  we, our owners, employees, and affiliates are not responsible
                  for any financial losses resulting from your reliance on our
                  content.
                </p>
                <p className="mb-3">
                  This Website may include links to third-party websites,
                  sponsored content, or affiliate promotions.
                </p>
                <p className="mb-3">
                  We do not own, control, or guarantee the accuracy,
                  reliability, or legitimacy of third-party services. If you
                  engage with third-party services through our links, you do so
                  at your own risk, and we are not responsible for any issues or
                  disputes arising from those engagements. We may earn a
                  commission from affiliate links, but this does not influence
                  our content recommendations.
                </p>
                <p className="mb-3">
                  By using this Website, you acknowledge that you have read and
                  understood our Privacy Policy, which outlines:
                </p>
                <p className="mt-0">
                  What personal data we collect (e.g., email, payment details,
                  analytics).
                </p>
                <p className="mt-0">How we use and store data.</p>
                <p className="mt-0">Third-party sharing policies</p>
                <p className="mt-0">
                  User rights, including data deletion requests.
                </p>
                <p className="mt-0">
                  For more details, refer to our Privacy Policy page.
                </p>

                <p className="mb-3">
                  All sales of digital products, including courses, are final
                  and non-refundable, except in cases of accidental duplicate
                  purchases
                </p>
                <p className="mb-3">
                  Users may not copy, distribute, or reproduce any content
                  without written permission. Unauthorized use of our content
                  may result in legal action
                </p>
                <p className="mb-3">
                  Users must not engage in fraud, harassment, illegal
                  activities, or violation of these terms. We reserve the right
                  to suspend or terminate any user account that violates these
                  terms
                </p>
                <p className="">
                  To the fullest extent permitted by law, we shall not be liable
                  for any direct, indirect, incidental, consequential, or
                  special damages arising from:
                </p>
                <p>Use of or inability to use our Website.</p>
                <p>Errors or inaccuracies in content.</p>
                <p>Third-party services or external links.</p>
                <p>Loss of profits, revenue, or financial losses.</p>
                <p className="mt-3 mb-3">
                  We reserve the right to modify or update this legal disclosure
                  at any time without prior notice. It is your responsibility to
                  review this page periodically for any changes.
                </p>

                <h5>Email Accuracy, Subscription Cancellation & Refund Policy</h5>
                <h6>1. Accuracy of Information</h6>
                <p className="mb-3">
                  By registering for our services, you are responsible for
                  providing accurate and complete information, including a
                  valid and correctly spelled email address. We will not be
                  responsible for any issues arising from an incorrect,
                  misspelled, or invalid email address entered by you during
                  registration.
                </p>
                <h6>2. Email Correction Period</h6>
                <p>
                  If you accidentally provide an incorrect or misspelled email
                  address during registration, you may contact our support
                  team within 24 hours of registration to request a
                  correction. Our support team may assist in correcting the
                  email address, subject to verification and applicable
                  procedures.
                </p>
                <p className="mb-3">
                  After the 24-hour period has expired, we will not be
                  responsible for any issues resulting from an incorrect email
                  address, and no refund or compensation will be provided on
                  this basis.
                </p>
                <h6>3. Subscription Cancellation</h6>
                <p className="mb-3">
                  It is your sole responsibility to cancel your subscription
                  before the next billing cycle if you no longer wish to
                  continue using our services. Failure to cancel your
                  subscription in a timely manner will not constitute grounds
                  for a refund.
                </p>
                <h6>4. Customer Support</h6>
                <p className="mb-3">
                  If you experience any issues with your account or
                  subscription, you are responsible for contacting our support
                  team promptly and providing the necessary information to
                  resolve the issue. Failure to contact support in a timely
                  manner will not entitle you to a refund.
                </p>
                <h6>5. Refunds</h6>
                <p className="mb-3">
                  No refunds will be provided for issues resulting from
                  incorrect information provided by the customer, failure to
                  cancel a subscription, or failure to contact our support
                  team within the applicable time period.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={showCopyRight}
        onHide={handleCloseCopyRight}
        centered
      >
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseCopyRight}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM">
              <div className="showMoreModal py-4">
                <h3 className="mb-4">
                  ©️ 2026 Waqar Zaka /{" "}
                  <a
                    href="https://waqarzaka.net"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.waqarzaka.net
                  </a>{" "}
                  — All Rights Reserved
                </h3>

                <p className="mb-3">
                  All educational content provided on this platform—including
                  videos, tutorials, strategies, voiceovers, and written
                  material—is the exclusive intellectual property of Waqar Zaka
                  and is protected by international copyright laws.
                </p>

                <h5>Strictly Prohibited:</h5>

                <p className="mb-3">
                  Sharing, reselling, recording, or distributing any part of the
                  content—even by paid users
                </p>
                <p className="mb-3">
                  Uploading content to any public or private platforms (e.g.,
                  Telegram, YouTube, WhatsApp)
                </p>
                <p className="mb-3">
                  Giving access to non-paying individuals or groups in any form
                </p>
                <p className="mb-3">
                  No Exceptions: Being a paid member does not grant you
                  ownership or redistribution rights. All content is for
                  personal educational use only. Any unauthorized use, whether
                  by an individual or company, will result in immediate legal
                  action, including but not limited to:
                </p>
                <h5>Civil lawsuits for damages</h5>
                <p className="mb-3">
                  Criminal charges under applicable cyber and copyright laws
                </p>
                <p className="mb-3">
                  Public exposure and reporting to relevant authorities,
                  platforms, and service providers v
                </p>
                <p className="mb-3">
                  We actively monitor for copyright violations and maintain IP
                  logs to track any misuse.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </footer>
  );
};
